import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';

const BomProcessRow = (props) => {
    const { formObject, index, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn50">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "pName" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "costFormula" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unit1" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue useVal={1} format="hhmm" formObject={formObject} rowKey={rowKey} action={{ paramName: "estQty1" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "processCost" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "ohCost" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "estValue" }} />
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
            <span className='uiCell'>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "isOutsource" }} />
            </span>
            </li>
            <li className="uiColumnCenter uiColumn90">
            <span>
                <FormROValue className="uiSeqSpan" customWrapper="div" wrapperClass="uiSeq uiFProcess" 
                formObject={formObject} rowKey={rowKey} action={{ paramName: "seqNo" }} />
            </span>
            </li>
            <li className="uiColumnCenter uiColumn60 uiActionBlock">
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "edit",  
                            paramName: "editBtn",
                            actionParam: {pathKey: "OEXI"}, containerKey: "popup" }}
                            className="" ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  
                        paramName: "delBtn",
                        actionParam: {pathKey: "OEXI"}, containerKey: "row" }}
                        className="" ></FormButton>
            </li>
        </ul>
    )
}

export default BomProcessRow